import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/gen1.jpg'
import _imports_1 from '../assets/gen2.jpg'


const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "nes-container with-title mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Select Farm", -1)
const _hoisted_6 = { class: "nes-field mb-5" }
const _hoisted_7 = { class: "flex flex-col md:flex-row justify-center align-center gap-4" }
const _hoisted_8 = { class: "nes-container with-title mb-10 hidden" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Connect to a Farm", -1)
const _hoisted_10 = { class: "nes-field mb-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "farm" }, "Farm address:", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-5" }, " Farmer account not found :( Create a new one? ", -1)
const _hoisted_16 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_loading = _resolveComponent("loading")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfigPane),
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "can-cancel": false,
      "is-full-page": true
    }, null, 8, ["active"]),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Pls connect your wallet"))
      : _createCommentVNode("", true),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.farm=_ctx.WH_FARMS.gen1)),
                  class: _normalizeClass(["rounded-lg", _ctx.farm==_ctx.WH_FARMS.gen1?'ring-4 ring-offset-2 ring-green-500':'ring-0']),
                  width: 300,
                  height: 300,
                  src: _imports_0,
                  alt: "",
                  srcset: ""
                }, null, 2),
                _createElementVNode("img", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.farm=_ctx.WH_FARMS.gen2)),
                  class: _normalizeClass(["rounded-lg", _ctx.farm==_ctx.WH_FARMS.gen2?'ring-4 ring-offset-2 ring-green-500':'ring-0']),
                  width: 300,
                  height: 300,
                  src: _imports_1,
                  alt: "",
                  srcset: ""
                }, null, 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                id: "farm",
                class: "nes-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.farm) = $event))
              }, null, 512), [
                [_vModelText, _ctx.farm]
              ])
            ])
          ]),
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  farm: () => _ctx.farmAcc,
                  whitelistCreator: _ctx.farm == _ctx.WH_FARMS.gen1 ? _ctx.WL_CREATORS.gen1 : _ctx.WL_CREATORS.gen2,
                  loader: ()=> _ctx.isLoading,
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                  onVaultGdrs: _ctx.handleVaultGdrs,
                  onVaultUpdated: _ctx.handleVaultUpdated,
                  onStartLoading: _ctx.startLoading,
                  onStopLoading: _ctx.stopLoading
                }, {
                  default: _withCtx(() => [
                    (_ctx.farmerState === 'unstaked' && _ctx.showStakingButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "nes-btn is-success mr-5",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                        }, " Begin staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'staked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "nes-btn is-error mr-5",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'pendingCooldown')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "nes-btn is-error mr-5",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End cooldown "))
                      : _createCommentVNode("", true),
                    (_ctx.getRewardCount!='0')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "nes-btn is-warning",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                        }, " Claim " + _toDisplayString(_ctx.getRewardCount) + " $WEEH ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["vault", "farm", "whitelistCreator", "loader", "onSelectedWalletNft", "onVaultGdrs", "onVaultUpdated", "onStartLoading", "onStopLoading"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.farm!=undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          class: "nes-btn is-primary",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                        }, " New Farmer ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]))
  ], 64))
}